import { Typography, Stack, Box } from '@mui/material'

import { C1Card } from 'components/core/card/C1Card'
import { Route } from 'lib/routes'

import { FC, useState } from 'react'

type EndUserDashboardCardProps = {
    href: Route
    title: string
    subtitle: string
    IllustrationComponent: FC<{ active: boolean }>
}

export const EndUserDashboardCard: FC<EndUserDashboardCardProps> = ({
    href,
    title,
    subtitle,
    IllustrationComponent,
}) => {
    const [isActive, setIsActive] = useState(false)

    return <C1Card
        sx={{ p: 0, flex: 1, mb: 0, overflow: 'hidden', borderColor: 'border.subtle' }}
        onMouseEnter={(): void => setIsActive(true)}
        onMouseLeave={(): void => setIsActive(false)}
        href={href}
    >
        <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            height: '100%',
        }}
        >
            <Box sx={{
                overflow: 'hidden',
                backgroundColor: 'primary.extraLight',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',

                '& svg': {
                    height: '100%',
                    minHeight: '80px',
                },
            }}
            >
                <IllustrationComponent active={isActive} />
            </Box>
            <Stack gap={1} p={4} px={5} justifyContent="center">
                <Typography variant="h5" component="div">{title}</Typography>
                <Typography>{subtitle}</Typography>
            </Stack>
        </Box>
    </C1Card>
}
